import { render, staticRenderFns } from "./zjjn.vue?vue&type=template&id=290d924e&scoped=true&"
import script from "./zjjn.vue?vue&type=script&lang=js&"
export * from "./zjjn.vue?vue&type=script&lang=js&"
import style0 from "./zjjn.vue?vue&type=style&index=0&id=290d924e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d924e",
  null
  
)

export default component.exports